

  <div class="tw:container tw:mx-auto tw:px-[15px]">
	<div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
	 <div id="Smallchat">
    <div class="Layout Layout-open Layout-expand Layout-right" [hidden]="!showChat">
      <div class="Messenger_messenger">
        <div class="Messenger_header">
          <h4 class="Messenger_prompt">How can we help you?</h4> 
          <div class="chat_close_icon modal-close-icon" (click)="toggleChat()"></div>
        </div>
        <div class="Messenger_content">
          
            <div class="flex">
                <div class="main-container">
                    <div class="webchat-container" #botWindow></div>
                </div>
              </div>

        </div>
      </div>
    </div>
    <!--===============CHAT ON BUTTON START===============-->
    <div class="chat_on" [hidden]="showChat" (click)="toggleChat()"> 
        <span class="chat_on_icon">
            <i class="las la-robot" aria-hidden="true"></i>
        </span> 
    </div>
    <!--===============CHAT ON BUTTON END===============-->
  </div>
	</div>
</div>